import React, { useState, useRef, useEffect, useCallback } from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import PopupFilter from '../../../common/components/PopupFilter/PopupFilter';

import moment from 'moment';
import AllLeadDashboardMobileEachElement from './AllLeadDashboardMobileEachElement';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../common/utils/FiltersInfo';
import CallMade from '../../../common/components/PopupFilter/FilterComponents/CallMade';
import RM from '../../../common/components/PopupFilter/FilterComponents/RmList';
import Status from '../../../common/components/PopupFilter/FilterComponents/Status';
import Product from '../../../common/components/PopupFilter/FilterComponents/Product';
import Source from '../../../common/components/PopupFilter/FilterComponents/Source';
import rmICon from '../../../images/icons/PopUpFilter/rmImg.svg';
import StyleIcon from '@material-ui/icons/Style';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';
import ShopIcon from '@material-ui/icons/Shop';
import DetailsIcon from '@material-ui/icons/Details';
import CircularProgress from '@material-ui/core/CircularProgress';
import MBTableSearchBox from '../../../components/CommonMbTableCard/MBTableSearchBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-light-svg-icons';
import _ from 'lodash';
import AddLeadsRmSide from '../../../containers/AddLead/AddLeadRmSide/AddLeadRmSide';
import plusIcon from '../../../images/icons/plus.svg';

const LeadfDashboardMobile = ({
  data,
  setStartDate,
  setEndDate,
  setSource,
  setFilterStatus,
  setFilterProductId,
  setRmId,
  tableLoading,
  tableInfo,
  setPage,
  setSearchPara,
  getLeadData,
  setShowWhatsApp,
  setUSerDataForWA,
  showSendDoc,
  setShowSendDoc
}) => {
  const appledFilters = filter => {
    setleads([]);
    setPage('0');
    setFiltersInfo({ ...getFiltersInfo(), leadDashboard: filter });
    let startDate = filter?.callMade?.startDate;
    let endDate = filter?.callMade?.toDate;
    let status = Object.keys(filter?.status || {})?.map(
      each => filter?.status[each]?.fullName
    );
    let product = Object.keys(filter?.product || {})?.map(
      each => filter?.product[each]?.id
    );
    setStartDate(
      moment(startDate)?.isValid()
        ? moment(startDate).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    );
    setEndDate(
      moment(endDate)?.isValid()
        ? moment(endDate).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    );
    setSource(Object.keys(filter?.source || {})?.toString());
    setFilterStatus(status?.toString());
    setFilterProductId(product?.toString());
    setRmId(Object.keys(filter?.rm || {})?.toString());
  };
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFields, setHtmlSelectedFileds] = useState({});
  const [leads, setleads] = useState([]);
  const [searchText, setSearchText] = useState(undefined);
  const [showAddLeadModal, setShowAddLeadModal] = useState(false);
  const [showAddlead, setAddLead] = useState(false);

  useEffect(() => {
    setleads([...leads, ...(data || [])]);
  }, [data]);

  const [masterFilters, setMasterFilters] = useState(
    getFiltersInfo()?.leadDashboard || {}
  );
  const dataDiv = useRef();

  const searchDiv = useRef();

  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };
  const rmImg = ({ className, style }) => (
    <SvgComponent
      img={rmICon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Date Filter',
      name: 'date',
      component: CallMade
    },
    {
      img: StyleIcon,
      title: 'Status',
      name: 'status',
      component: Status,
      dependencyData: { multiSelect: true }
    },
    {
      img: ShopIcon,
      title: 'Product',
      name: 'product',
      component: Product,
      dependencyData: { multiSelect: false }
    },
    {
      img: DetailsIcon,
      title: 'Source',
      name: 'source',
      component: Source,
      dependencyData: { multiSelect: false }
    },
    {
      img: rmImg,
      title: 'RM',
      name: 'rm',
      component: RM,
      dependencyData: { multiSelect: false }
    }
  ];

  let handleScroll = () => {
    const scrollHeight = dataDiv?.current?.scrollHeight;
    const scrollTop = dataDiv?.current?.scrollTop;
    const clientHeight = dataDiv?.current?.clientHeight;

    if (
      scrollHeight - scrollTop - clientHeight < 30 &&
      !tableLoading &&
      tableInfo?.number < tableInfo?.totalPages - 1
    ) {
      setPage(tableInfo?.number + 1);
    }
  };

  handleScroll = _.debounce(handleScroll, 50);

  let seachHandler = () => {
    setleads([]);
    setSearchPara(_.get(searchDiv, 'current.children.[0].value', ''));
  };
  const updateData = () => {
    setleads([]);
    getLeadData();
  };

  const seachHandle = useCallback(_.debounce(seachHandler, 300), []);
  return (
    <div className="w-full">
      {showAddlead && (
        <AddLeadsRmSide
          showModal={showAddLeadModal}
          setShowModal={setShowAddLeadModal}
          setAddLead={setAddLead}
          onAddLeadAdded={updateData}
        />
      )}

      <div className="w-full text-right">
        <button
          className=" w-48 h-12 mr-3 mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md ml-auto"
          onClick={() => {
            setShowAddLeadModal(true), setAddLead(true);
          }}
        >
          <div className="mx-auto inline-flex ">
            <img className="block mr-2 -mt-px " src={plusIcon} alt="+" />
            <span className="text-base py-3 block">Add Lead</span>
          </div>
        </button>
      </div>

      <span className="px-3 flex  pt-4 pb-2">
        <span
          className="flex px-2 border border-grey-2239 rounded items-center h-10"
          onClick={() => {
            setShowFilter(true);
          }}
        >
          <span>
            <FontAwesomeIcon icon={faFilter} style={{ color: '#212B34' }} />
          </span>
          <span className="text-black-850 text-sm mr-2 ml-1">Filter</span>
        </span>

        <div className="w-full">
          <MBTableSearchBox
            searchbar={searchText}
            setSearchBar={setSearchText}
            onChangeEvent={seachHandle}
            inputContainerRef={searchDiv}
          />
        </div>
      </span>

      <div className="w-full flex flex-wrap">
        {Object.keys(selectedFields || {}).map(each => selectedFields[each])}
      </div>
      <div
        className="w-full"
        style={{ maxHeight: '80vh', overflow: 'auto' }}
        onScroll={handleScroll}
        ref={dataDiv}
      >
        {leads?.map((each, index) => (
          <AllLeadDashboardMobileEachElement
            each={each}
            key={index}
            tableLoading={tableLoading}
            tableInfo={tableInfo}
            setPage={setPage}
            updateData={updateData}
            setShowWhatsApp={setShowWhatsApp}
            setUSerDataForWA={setUSerDataForWA}
            showSendDoc={showSendDoc}
            setShowSendDoc={setShowSendDoc}
          />
        ))}
        {tableLoading && (
          <div className="table mx-auto pt-3">
            <CircularProgress />
          </div>
        )}
        {!tableLoading && leads?.length != 0 && (
          <p className="font-normal text-black-500 w-full text-center my-4 mx-4">
            No More Leads!
          </p>
        )}
        {!tableLoading && leads?.length == 0 && (
          <p className="font-normal text-black-500 w-full text-center my-4 mx-4">
            No Leads Found!
          </p>
        )}
      </div>
      <PopupFilter
        show={showFilter}
        setShow={setShowFilter}
        dataList={dataList}
        handleApply={appledFilters}
        handleToastBlock={e => setHtmlSelectedFileds(e)}
        masterFiltersData={masterFilters}
      />
    </div>
  );
};

export default LeadfDashboardMobile;
